import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import { Button } from './Button.js';
import './Navbar.css';

function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
    const [LoggedIn, setLogin] = useState(false)

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const menuFooter = <svg width="209" height="268" viewBox="0 0 209 268" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_3391_2744)">
    <g clip-path="url(#clip0_3391_2744)">
    <rect x="161" y="111" width="47.8333" height="49" rx="23.9167" fill="#D3FAC7"/>
    <g filter="url(#filter1_f_3391_2744)">
    <ellipse cx="182.884" cy="131.297" rx="25.9496" ry="26.0613" fill="#FFFBE7"/>
    </g>
    <g opacity="0.7" filter="url(#filter2_f_3391_2744)">
    <circle cx="179.084" cy="124.125" r="16.0417" fill="#FFFBE7"/>
    </g>
    <g filter="url(#filter3_f_3391_2744)">
    <ellipse cx="6.80092" cy="4.1612" rx="6.80092" ry="4.1612" transform="matrix(0.981129 -0.193352 0.191759 0.981442 181.329 150.62)" fill="#64E296"/>
    </g>
    </g>
    </g>
    <g filter="url(#filter4_i_3391_2744)">
    <g clip-path="url(#clip1_3391_2744)">
    <rect x="83" y="182" width="83" height="85.0244" rx="41.5" fill="#D3FAC7"/>
    <g filter="url(#filter5_f_3391_2744)">
    <ellipse cx="120.973" cy="217.219" rx="45.0275" ry="45.2213" fill="#FFFBE7"/>
    </g>
    <g opacity="0.7" filter="url(#filter6_f_3391_2744)">
    <circle cx="114.379" cy="204.775" r="27.8354" fill="#FFFBE7"/>
    </g>
    <g filter="url(#filter7_f_3391_2744)">
    <ellipse cx="11.8009" cy="7.22048" rx="11.8009" ry="7.22048" transform="matrix(0.981129 -0.193352 0.191759 0.981442 118.275 250.749)" fill="#64E296"/>
    </g>
    </g>
    </g>
    <g filter="url(#filter8_i_3391_2744)">
    <g clip-path="url(#clip2_3391_2744)">
    <rect y="60" width="26.3571" height="27" rx="13.1786" fill="#D3FAC7"/>
    <g filter="url(#filter9_f_3391_2744)">
    <ellipse cx="12.0586" cy="71.1839" rx="14.2987" ry="14.3603" fill="#FFFBE7"/>
    </g>
    <g opacity="0.7" filter="url(#filter10_f_3391_2744)">
    <circle cx="9.96447" cy="67.2322" r="8.83928" fill="#FFFBE7"/>
    </g>
    <g filter="url(#filter11_f_3391_2744)">
    <ellipse cx="3.74745" cy="2.29291" rx="3.74745" ry="2.29291" transform="matrix(0.981129 -0.193352 0.191759 0.981442 11.2017 81.8315)" fill="#64E296"/>
    </g>
    </g>
    </g>
    <g filter="url(#filter12_i_3391_2744)">
    <g clip-path="url(#clip3_3391_2744)">
    <rect x="108" width="17" height="17.4146" rx="8.5" fill="#D3FAC7"/>
    <g filter="url(#filter13_f_3391_2744)">
    <ellipse cx="115.778" cy="7.2135" rx="9.2225" ry="9.2622" fill="#FFFBE7"/>
    </g>
    <g opacity="0.7" filter="url(#filter14_f_3391_2744)">
    <circle cx="114.427" cy="4.66473" r="5.70122" fill="#FFFBE7"/>
    </g>
    <g filter="url(#filter15_f_3391_2744)">
    <ellipse cx="2.41705" cy="1.47889" rx="2.41705" ry="1.47889" transform="matrix(0.981129 -0.193352 0.191759 0.981442 115.226 14.081)" fill="#64E296"/>
    </g>
    </g>
    </g>
    <defs>
    <filter id="filter0_i_3391_2744" x="161" y="111" width="47.8334" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="1.16667" operator="erode" in="SourceAlpha" result="effect1_innerShadow_3391_2744"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="4.375"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.9875 0 0 0 0 0.645509 0 0 0 0 0.576042 0 0 0 0.6 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3391_2744"/>
    </filter>
    <filter id="filter1_f_3391_2744" x="139.435" y="87.7353" width="86.8991" height="87.1226" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="8.75" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter2_f_3391_2744" x="148.459" y="93.5001" width="61.25" height="61.25" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="7.29167" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter3_f_3391_2744" x="173.329" y="140.348" width="30.9416" height="26.0832" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="4.375" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter4_i_3391_2744" x="83" y="182" width="83" height="85.0244" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="2.02439" operator="erode" in="SourceAlpha" result="effect1_innerShadow_3391_2744"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="7.59146"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.9875 0 0 0 0 0.645509 0 0 0 0 0.576042 0 0 0 0.6 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3391_2744"/>
    </filter>
    <filter id="filter5_f_3391_2744" x="45.5798" y="141.631" width="150.787" height="151.174" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="15.1829" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter6_f_3391_2744" x="61.2384" y="151.634" width="106.28" height="106.28" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="12.6524" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter7_f_3391_2744" x="104.393" y="232.924" width="53.6896" height="45.2594" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="7.59146" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter8_i_3391_2744" x="0" y="60" width="26.3571" height="27" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="0.642857" operator="erode" in="SourceAlpha" result="effect1_innerShadow_3391_2744"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="2.41071"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.9875 0 0 0 0 0.645509 0 0 0 0 0.576042 0 0 0 0.6 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3391_2744"/>
    </filter>
    <filter id="filter9_f_3391_2744" x="-11.883" y="47.1807" width="47.8832" height="48.0063" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="4.82143" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter10_f_3391_2744" x="-6.91053" y="50.3572" width="33.75" height="33.75" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="4.01786" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter11_f_3391_2744" x="6.79344" y="76.1711" width="17.0494" height="14.3724" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="2.41071" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter12_i_3391_2744" x="108" y="0" width="17" height="17.4146" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="0.414634" operator="erode" in="SourceAlpha" result="effect1_innerShadow_3391_2744"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="1.55488"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.9875 0 0 0 0 0.645509 0 0 0 0 0.576042 0 0 0 0.6 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3391_2744"/>
    </filter>
    <filter id="filter13_f_3391_2744" x="100.336" y="-8.2682" width="30.884" height="30.9634" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="3.10976" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter14_f_3391_2744" x="103.542" y="-6.21941" width="21.7683" height="21.7683" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="2.59146" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <filter id="filter15_f_3391_2744" x="112.382" y="10.4301" width="10.9966" height="9.27" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="1.55488" result="effect1_foregroundBlur_3391_2744"/>
    </filter>
    <clipPath id="clip0_3391_2744">
    <rect x="161" y="111" width="47.8333" height="49" rx="23.9167" fill="white"/>
    </clipPath>
    <clipPath id="clip1_3391_2744">
    <rect x="83" y="182" width="83" height="85.0244" rx="41.5" fill="white"/>
    </clipPath>
    <clipPath id="clip2_3391_2744">
    <rect y="60" width="26.3571" height="27" rx="13.1786" fill="white"/>
    </clipPath>
    <clipPath id="clip3_3391_2744">
    <rect x="108" width="17" height="17.4146" rx="8.5" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
    
    const showButton = () => {
        if(window.innerWidth <=960){
            setButton(false);
        } else{
            setButton(true);
        }
    };
    const isLoggedIn = () => {
        try{
            var user = JSON.parse(localStorage.user).user;
            console.log(user)
            setLogin(true)
        } catch(e){
            user = false 
            setLogin(false)
        }
    }

    useEffect(() =>{
        showButton();
        isLoggedIn();
    }, []);

    let headerColor = "bg-white"
    if (window.location.href.includes("/about") || window.location.href.includes("/careers")){
        headerColor = "bg-[#FAF4FD]"
    }

    let mobile = false
	if (window.screen.width < 708){
		mobile = true
	}

    let header = 
    <nav className={click ? `navbar active ${headerColor}` : `navbar active ${headerColor}`}>
        <div className="navbar-container">
            <div className='flex justify-between'>
                <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                    <img className='logo' alt="bubble africa" src='./images/bubble.svg' />
                </Link>
                <div className={click ? 'menu-icon-bg rounded-full p-[11px] bg-[#E0E0E0]' : "menu-icon"}  onClick={handleClick}>
                    <img className='' alt="bubble africa" src={click ? './images/cancel.svg' : './images/menu.svg'} />
                    {/* <i className={click ? 'fas fa-times' : 'fas fa-bars'} /> */}
                </div>
            </div>
                <ul className={click ? `nav-menu active ${headerColor}` : 'nav-menu'}>
                    {
                        LoggedIn ? (
                            <>
                                {/* <li className='navItem'>
                                    <Link to='/find-a-roommate' className='nav-links' onClick={closeMobileMenu}>
                                        Find a roommate
                                    </Link>
                                </li> */}
                                
                                <li className='nav-item'>
                                    <Link to='/rent-a-home' className='nav-links' onClick={closeMobileMenu}>
                                        Rent a home
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/landlord' className='nav-links' onClick={closeMobileMenu}>
                                        List a space
                                    </Link>
                                </li>

                                <li className='nav-item'>
                                    <Link to='/dashboard' className='nav-links green-text' onClick={closeMobileMenu}>
                                        My dashboard
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/logout' className='nav-links logout' onClick={closeMobileMenu}>
                                        Logout
                                    </Link>
                                </li>
                            </>
                            
                        ):(
                            <>
                                {/* <li className='navItem'>
                                    <Link to='/find-a-roommate' className='nav-links' onClick={closeMobileMenu}>
                                        Find a roommate
                                    </Link>
                                </li> */}
                                
                                <li className='nav-item'>
                                    <Link to='/rent-a-home' className='nav-links' onClick={closeMobileMenu}>
                                        Rent a home
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/landlord' className='nav-links' onClick={closeMobileMenu}>
                                        List a space
                                    </Link>
                                </li>

                                <li className='nav-item'>
                                    <Link to='/login' className='nav-links' onClick={closeMobileMenu}>
                                        Login
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <a className="nav-links sign-up" href="/sign-up">Sign Up</a>
                                </li>
                            </>
                        )
                    }
                {click ? menuFooter : null }
            </ul>
            {/* {button && <Button buttonStyle='btn--outline'>Sign Up</Button>} */}
            
        </div>
    </nav>

    if (window.location.href.includes("/app")){
        console.log("It's there")
        header = ""
    
    }


    
    window.addEventListener('resize', showButton);
    
    return (
        <>
            {header}
        </>
    );
}

export default Navbar;
